import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetRevisionNotes(data = {}) {
  const { enabled = false, configs = {}, topicId } = data;
  const { params = {} } = configs;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function listRevisionNotes() {
    return privateFetch.get(`/v1/admin/topic/${topicId}/revision`, configs).then((res) => res.data);
  }

  return useQuery(['revision-notes', params], listRevisionNotes, {
    enabled,
    keepPreviousData: true,
  });
}

export default useGetRevisionNotes;
